module.exports = __webpack_public_path__ + "img/aimReport.f38286ec.svg";